import React from 'react'

const Trash = (props) => (
  <svg width={18} height={23} {...props}>
    <title>AB716842-E959-4F32-9223-5AC28DF57F0A</title>
    <g fill="none" fillRule="evenodd">
      <path
        d="M1.594 8.675c-.042-.253.098-.413.362-.413h12.691c.262 0 .403.162.362.413L13.175 19.84c-.058.35-.431.662-.79.662H4.217c-.358 0-.732-.314-.789-.662L1.594 8.675zm-1.566.248l1.834 11.165c.18 1.102 1.218 1.972 2.355 1.972h8.168c1.138 0 2.175-.868 2.356-1.972l1.834-11.165c.197-1.198-.689-2.22-1.928-2.22H1.956c-1.24 0-2.126 1.02-1.928 2.22z"
        fill="#222222"
        fillRule="nonzero"
      />
      <path
        d="M2.093 3.787l-.063.434a.438.438 0 00.382.494l12.937 1.768a.445.445 0 00.507-.373l.063-.434a.438.438 0 00-.382-.494L2.6 3.415a.445.445 0 00-.507.372zM.532 3.574c.155-1.076 1.174-1.829 2.287-1.677l12.938 1.768c1.108.151 1.879 1.145 1.723 2.224l-.063.435C17.262 7.4 16.242 8.152 15.13 8L2.192 6.233C1.084 6.08.312 5.087.47 4.008l.063-.434z"
        fill="#222222"
        fillRule="nonzero"
      />
      <path
        d="M11.505 3.499c.151-.958-.619-1.875-1.72-2.05-1.102-.174-2.118.46-2.27 1.418"
        stroke="#222222"
        strokeWidth={1.333}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.596 10.82a.498.498 0 01.437-.554l.341-.042a.5.5 0 01.558.432l.895 7.288a.498.498 0 01-.437.554l-.341.042a.5.5 0 01-.558-.432l-.895-7.288zM11.222 10.656a.498.498 0 01.558-.432l.34.042a.5.5 0 01.438.554l-.895 7.288a.498.498 0 01-.558.432l-.341-.042a.5.5 0 01-.437-.554l.895-7.288z"
        fill="#222222"
      />
    </g>
  </svg>
)

export default Trash
